export default "__VITE_ASSET__BJlgLulu__"